<template>
	<div class="saveInfo">
		<div class="form">
			<el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="120px">
				<el-form-item label="用户名" class="item">
					<div>{{username}}</div>
				</el-form-item>
				<el-form-item label="手机号" prop="mobile" class="item">
					<el-input v-model="ruleForm.mobile" placeholder="请输入手机号"></el-input>
				</el-form-item>
				<el-form-item label="姓名" prop="nickname" class="item">
					<el-input v-model="ruleForm.nickname" placeholder="请输入姓名"></el-input>
				</el-form-item>
				<el-form-item label="QQ" prop="qq" class="item">
					<el-input v-model="ruleForm.qq" placeholder="请输入QQ号"></el-input>
				</el-form-item>
				<el-form-item label="邮箱" prop="email" class="item">
					<el-input v-model="ruleForm.email" placeholder="请输入邮箱"></el-input>
				</el-form-item>
				<el-form-item label="头像" prop="avatar" class="item">
					<myupload @resultUrl="onimgurl" :uptype="1" :imgurl.sync="ruleForm.avatar"></myupload>
				</el-form-item>
				<el-form-item label="售后服务电话" prop="after_mobile" class="item">
					<el-input v-model="ruleForm.after_mobile" placeholder="请输入售后服务电话"></el-input>
				</el-form-item>
				
			</el-form>
		</div>
		<div class="btndiv">
			<el-button type="primary" @click="onsub()">确定</el-button>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Company',
		data() {
			return {
				username: "",
				ruleForm: {
					mobile: "",
					nickname: "",
					qq: "",
					email: "",
					avatar: "",
					after_mobile: "",
				},

				rules: {
					mobile: [{
						required: true,
						message: '请输入您的手机号',
						trigger: 'blur'
					}],

					nickname: [{
						required: true,
						message: '请输入您的姓名',
						trigger: 'blur'
					}],

					qq: [{
						required: true,
						message: '请输入您的QQ号',
						trigger: 'blur'
					}],

					email: [{
							required: true,
							message: '请输入您的邮箱',
							trigger: 'blur'
						},
						{
							type: 'email',
							message: '请输入正确的邮箱地址',
							trigger: 'blur'
						}
					],

					after_mobile: [{
						required: true,
						message: '请输入售后服务电话',
						trigger: 'blur'
					}]
				}
			}
		},
		
		inject: ['appdata','reload'],

		methods: {
			onimgurl(v) {
				this.ruleForm.avatar = v;
			},
			
			oninfo() {
				this.$axios.get('api/user/info').then(res => {
					if (res.data.code == 0) {
						for (let key in this.ruleForm) {
							this.ruleForm[key] = res.data.data[key];
						}
						
						this.username =  res.data.data.username;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onsub() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						var obj = JSON.parse(JSON.stringify(this.ruleForm));
						this.$axios.post('api/user/user_save_info', obj).then(res => {
							if (res.data.code == 0) {
								this.$message.success('操作成功');
								this.oninfo();
								this.reload();
							} else {
								this.$message.error(res.data.message);
							}
						}).catch(err => {
							console.log(err)
						})
					}
				})
			}
		},
		
		mounted() {
			this.oninfo();
		}
	}
</script>

<style scoped lang="less">
	.saveInfo {
		padding: 20px 0;
	}

	.btndiv {
		width: 100%;
		display: flex;
		justify-content: center;
	}

	/deep/ .item .el-input {
		width: 400px;
	}
</style>



// WEBPACK FOOTER //
// src/components/buyer/saveInfo.vue